import axios from "axios";

export default axios.create({
  baseURL: "https://profrafaelpontes.unifap.br/api/observatorio/",
  // timeout: 1000
});
